import './desc.scss';
import state from '../../state';
function Desc() {
return (
    <div className="desc">
        <div className="main_header">
            Поднимая звучание на новый уровень
        </div>
        <div className="main_desc">
            {state.Main.Desc.desc}
        </div>
        <div className="main_desc">
            <div className="title">
                {state.Main.Desc.title_1}
            </div>
            <div className="text">
                {state.Main.Desc.text_1}
            </div>
        </div>
        <img  className="pic"src="/img/silver.png" alt="Silver"></img>
        <div className="main_desc">
            <div className="title">
                {state.Main.Desc.title_2}
            </div>
            <div className="text">
                {state.Main.Desc.text_2[0]}
            </div>
            <div className="text">
                {state.Main.Desc.text_2[1]}
            </div>
        </div>
    </div>
)}
export default Desc;
